import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { USER_READ, hasPrivilege } from 'utils/privileges';
import Stack from 'components/Stack';
import SparkPanel from 'components/SparkPanel';
import { AssetActivityLog, AssetPopularUsersStats } from 'components/InlineStatsPanel';
var AssetAnalyticsPage = function AssetAnalyticsPage(_ref) {
  var id = _ref.id,
    playlistId = _ref.playlistId,
    name = _ref.name,
    type = _ref.type;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(SparkPanel, {
    title: t('panel_asset_stats_title'),
    id: id,
    type: type
  }), hasPrivilege(USER_READ) && /*#__PURE__*/React.createElement(AssetPopularUsersStats, {
    title: t('analytics_most_active_users'),
    assetId: id,
    playlistId: playlistId
  }), hasPrivilege(USER_READ) && /*#__PURE__*/React.createElement(AssetActivityLog, {
    title: t('analytics_activity_log'),
    assetId: id,
    name: name
  }));
};
export default AssetAnalyticsPage;